"use client";

import { Layout } from 'antd';
import styles from './QA.module.scss';
import { ScrollReveal } from '@/shared/ui/ScrollReveal';
import { useTranslations } from 'next-intl';

const { Content } = Layout;

const qaData = [
  {
    id: 1,
    question: 'rightFreeQ',
    answer: 'rightFreeA',
  },
  {
    id: 2,
    question: 'noUploadQ',
    answer: 'noUploadA',
  },
  {
    id: 3,
    question: 'noLimitsQ',
    answer: 'noLimitsA',
  },
  {
    id: 4,
    question: 'keepQualityQ',
    answer: 'keepQualityA',
  },
];

export const QA = () => {
  const t = useTranslations('textRemover.qa');

  return (
    <Content className={styles.root}>
      <ScrollReveal className={styles.root_title}>
        <h1>{t('questions')}</h1>
        <h1>{t('answers')}</h1>
      </ScrollReveal>

      <ScrollReveal className={styles.root_items}>
        {qaData.map((item) => (
          <div key={item.id} className={styles.root_items_item}>
            <div className={styles.root_items_item_icon}>Q</div>
            <h3>{t(item.question)}</h3>
            <div />
            <p>{t(item.answer)}</p>
          </div>
        ))}
      </ScrollReveal>
    </Content>
  );
};
